export default "__VITE_ASSET__CSG6fO5R__"